import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./LoadingScreen.css";

const LoadingScreen: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Prevent scrolling when loading
    document.body.style.overflow = "hidden";

    const timer = setTimeout(() => {
      setIsVisible(false);
      // Re-enable scrolling after animation
      setTimeout(() => {
        document.body.style.overflow = "unset";
      }, 1000);
    }, 2500); // Slightly longer to appreciate the entrance

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "unset";
    };
  }, []);

  const containerVariants = {
    initial: {
      y: 0,
    },
    exit: {
      y: "-100%",

      transition: {
        duration: 1.2,
        ease: [0.76, 0, 0.24, 1], // Cinematic ease
        when: "afterChildren", // Wait for logo to start exiting
      },
    },
  };

  const logoVariants = {
    initial: {
      opacity: 0,
      scale: 0.8,
      y: 20,
      filter: "blur(10px)",
    },
    animate: {
      opacity: 1,
      scale: 1,
      y: 0,
      filter: "blur(0px)",
      transition: {
        // duration: 1.2,
        duration: 1.2,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      scale: 1.1,
      y: -100, // Parallax effect (moves up slightly as bg moves up)
      filter: "blur(10px)",
      transition: {
        duration: 0.8,
        ease: "easeInOut",
      },
    },
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="loading-screen-container"
          variants={containerVariants}
          initial="initial"
          animate="initial" // Keep it at initial state until exit
          exit="exit"
          key="loading-screen"
        >
          <motion.div
            className="loading-logo-wrapper"
            variants={logoVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            {/* <img
              src="/logo.webp"
              alt="Yolla Food"
              className="loading-logo-image"
            /> */}
            <video
              src="/logo.mp4"
              autoPlay
              loop
              muted
              className="loading-logo-image"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;
